import '../../styles/field.css';
import './BaseChip.css';
import './ChipContent.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var content = _7a468({defaultClassName:'_19aex2c1-2-0-1',variantClassNames:{size:{'default':'_19aex2c2-2-0-1',condensed:'_19aex2c3-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var prefix = '_19aex2c4-2-0-1';